import { Box, Button, Chip, Grid, Skeleton, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getStudentOfferCategory } from '../../../../service/student.offers.service';
import { SET_CATEGORY } from '../../../../redux/offer.reducer';

function CustomRow({ children }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      {children}
    </Stack>
  );
}

CustomRow.propTypes = {
  children: PropTypes.node
};

export default function OfferBanner() {
  // Offer category
  const offerCategories = useSelector((state) => state.offers.categories);
  // Loading
  const [loading, setLoading] = useState(offerCategories === null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchCategories() {
      const offerCategory = await getStudentOfferCategory();
      if (offerCategory) {
        dispatch({ type: SET_CATEGORY, payload: offerCategory });
      }
      setLoading(false);
    }

    if (offerCategories === null) fetchCategories();
  }, []);

  console.log('Line----41 OfferBanner.js', offerCategories);
  return (
    <Box>
      <Grid container spacing={1}>
        {loading
          ? [0, 1].map((_, index) => (
              <Grid item key={index} xs={12} sm={6}>
                <Skeleton variant="rounded" height={200} />
              </Grid>
            ))
          : offerCategories?.map((category, index) => {
              if (index === 0) return null;
              return (
                <Grid item key={category._id} xs={12} sm={6}>
                  <Box
                    sx={{
                      backgroundImage: `url(https://cms.fainlearn.com${category?.banner[0].url})`,
                      height: 200,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      borderRadius: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                      alignItems: 'flex-start',
                      p: 2,
                      cursor: 'pointer'
                    }}
                    onClick={() =>
                      navigate(`/dashboard/offers`, {
                        state: {
                          category
                        }
                      })
                    }
                  >
                    <Chip
                      label={category.category_name}
                      style={{
                        color: 'white',
                        backgroundColor: 'rgba(145, 158, 171, 0.50)',
                        marginBottom: 5
                      }}
                    />
                    <Typography color="white" fontWeight="600">
                      {category.title}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
      </Grid>
      {!loading && (
        <Button onClick={() => navigate('/dashboard/offers')} sx={{ mt: 3, mx: 'auto' }}>
          See All
        </Button>
      )}
    </Box>
  );
}
